import React from "react";

import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { useState } from "react";
import { data } from "jquery";
import {
  SetActionForLeaveTypes,
  SetLeaveTypeRetrieveActions,
  SetLeaveTypeEditActions,
} from "../../../Redux/Slice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

const LeaveTypeCreate = (props) => {
  const { setShow, show, currentPage, EditID , search } = props;
 // console.log(EditID, "EditIss");
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const Headers = {
    LeaveType: "",
    Description: "",
    unique_value:""
  };
  const [Data, setDatas] = useState(Headers);
  const [LeaveTypeError, setLeaveTypeError] = useState("");
  const [DescriptionErr, setDescriptionError] = useState("");
  useEffect(() => {
    if (EditID != undefined && EditID != "") {
      const payload = {
        EditID: EditID,
      };
      dispatch(SetLeaveTypeRetrieveActions(payload));
    }
  }, []);
  console.log(state.LeaveTypeRetrieveCall, "ADASD");
  useEffect(() => {
    if (
      EditID != undefined &&
      EditID != "" &&
      state.LeaveTypeRetrieveCall.LeaveTypeRetrieve.id
    ) {
      setDatas({
        LeaveType: state.LeaveTypeRetrieveCall.LeaveTypeRetrieve.leave_type,
        Description: state.LeaveTypeRetrieveCall.LeaveTypeRetrieve.description,
      });
    }
  }, [state.LeaveTypeRetrieveCall.LeaveTypeRetrieve]);
  const HandleChanges = (e) => {
    setDatas((pre) => {
      return {
        ...pre,
        [e.target.name]: e.target.value,
      };
    });
  };
  const HandleSubmits = (e) => {
    e.preventDefault();
  };
  const handleClose = () => {
    setShow(false);
  };
  const HandleSubmit = () => {
    var a = 0;
    if (EditID == undefined || EditID == "") {
      if (Data.LeaveType == "") {
        a = 1;
        setLeaveTypeError("*Leave type Is required");
      }
      if (Data.Description == "") {
        a = 1;
        setDescriptionError("*Description is required");
      }
      if (a == 0) {
        const payload = {
          Data: Data,
          setShow: setShow,
          currentPage: currentPage,
          unique_value:Data.LeaveType.toLowerCase()
          .replace(/\s+/g, "_")
          .replace(/[^a-z0-9_]/g, "_"),
          search:search,
        };
        dispatch(SetActionForLeaveTypes(payload));
        setShow(false);
      }
    }
  };
  const HandleEdits = (e) => {
    var a = 0;
    if (EditID != undefined && EditID != "") {
      if (Data.LeaveType == "") {
        a = 1;
        setLeaveTypeError("*Leave type Is required");
      }
      if (Data.Description == "") {
        a = 1;
        setDescriptionError("*Description is required");
      }
      if (a == 0) {
        const payload = {
          Data: Data,
          setShow: setShow,
          currentPage: currentPage,
          EditID: EditID,
          unique_value:Data.LeaveType.toLowerCase()
          .replace(/\s+/g, "_")
          .replace(/[^a-z0-9_]/g, "_"),
          search:search,

        };
        dispatch(SetLeaveTypeEditActions(payload));
        setShow(false);
      }
    }
  };
  return (
    <>
      <div className="RoleCreatePopup">
        <div className="BeforePopUp">
          <div className="RolePopups" style={{ width: "30%" }}>
            <div className="asds">
              <div class="ModalHeader">
                {EditID != undefined && EditID != "" ? (
                  <span className="UserCreate"> Leave Type  </span>
                ) : (
                  <span className="UserCreate"> Leave Type  </span>
                )}

                <div className="CloseIcon" onClick={(e) => setShow(false)}>
                  <CloseOutlinedIcon />
                </div>
              </div>
              <form class="row g-3 form-fields-wrapper" onClick={HandleSubmits}>
                <div className="col-12 field-div">
                  <label className="form-label" style={{ fontSize: "15px" }}>
                    Leave Type                                   <span style={{ color: "red" }}>*</span>

                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={Data.LeaveType}
                    autoComplete="off"
                    onChange={(e) => {
                      HandleChanges(e);
                      setLeaveTypeError("");
                    }}
                    required
                    name="LeaveType"
                    style={{
                      padding: "10px",
                    }}
                  ></input>
                  <p style={{ color: "red", marginTop: "5px" }}>
                    {LeaveTypeError}
                  </p>
                </div>

                <div className="col-12 field-div">
                  <label className="form-label" style={{ fontSize: "15px" }}>
                    Description                                   <span style={{ color: "red" }}>*</span>

                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={Data.Description}
                    autoComplete="off"
                    onChange={(e) => {
                      HandleChanges(e);
                      setDescriptionError("");
                    }}
                    required
                    name="Description"
                    style={{
                      padding: "10px",
                    }}
                  ></input>
                  <p style={{ color: "red", marginTop: "5px" }}>
                    {DescriptionErr}
                  </p>
                </div>
              </form>
              <div
                className="RoleButton"
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <button
                  class="btn  SaveBtn"
                  type="submit"
                  onClick={(e) => {
                    HandleSubmit(e);
                    HandleEdits(e);
                  }}
                >
                  Submit
                </button>
                <button class="btn CancelBtn" onClick={handleClose}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaveTypeCreate;
